import { createContext, useContext } from "react";
import { useFilter } from "../../../../../hooks/filter";
import { FilterBody } from "../../../../../hooks/filter/typing";
import { formatFilterMainDepartments } from "../initialState";

const DepartmentContext = createContext<{
    filterMain: FilterBody
}>(Object({}))
export const useDepartmentContext = () => useContext(DepartmentContext)

export const DepartmentContextProvider = ({ children }: { children: JSX.Element }) => {
    const filterMain = useFilter({ formatFilter: formatFilterMainDepartments })
    return (
        <DepartmentContext.Provider value={{
            filterMain
        }}>
            {children}
        </DepartmentContext.Provider>
    )
}